import {
  SHOW_WIZARD,
  SET_CURRNET_WIZRD_PAGE,
  SET_CURRNET_WIZRD,
  SET_WIZARD_ERROR_MESSAGE,
  SET_WIZARD_CATEGORY,
  SET_CURRENT_WIZARD_DATA,
  CLEAR_WIZARD,
} from "../actions/types";
const initialState = {
  isWizardOpen: false,
  currentPage: 0,
  currentWizard: "",
  errorMessage: "",
  currentCategory: "",
  currentData: null,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_WIZARD:
      return {
        ...state,
        isWizardOpen: action.payload,
      };
    case SET_CURRNET_WIZRD_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_CURRNET_WIZRD:
      return {
        ...state,
        currentWizard: action.payload,
      };
    case SET_WIZARD_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_WIZARD_CATEGORY:
      return {
        ...state,
        currentCategory: action.payload,
      };
    case SET_CURRENT_WIZARD_DATA:
      return {
        ...state,
        currentData: action.payload,
      };
    case CLEAR_WIZARD:
      return {
        ...state,
        isWizardOpen: false,
        currentPage: 0,
        currentWizard: "",
        errorMessage: "",
        currentCategory: "",
        currentData: null,
      };
    default:
      return state;
  }
}
